export enum EventConfirmationStateEnum {
  DELAYED = 'DELAYED',
  CONFIRMED = 'CONFIRMED',
  DECLINE = 'DECLINE',
  WAITING = 'WAITING',
}
